"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadBill = exports.WNSConfigName = exports.downloadprint = exports.download = exports.epochToYmdDate = exports.downloadReceiptFromFilestoreID = exports.GetMdmsNameBycode = exports.setApplicationNumberBox = exports.furnishNocResponse = exports.prepareDocumentsUploadRedux = exports.prepareDocumentsUploadData = exports.createUpdateNocApplication = exports.getSearchResults = exports.userUnlock = exports.transactionUpdateAxis = exports.transactionUpdate = exports.getuserSearchResults = exports.getConsumerTransactionSearchResults = exports.findItemInArrayOfObject = exports.getLocaleLabelsforTL = exports.getFileUrlFromAPIWS = undefined;

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _utils = require("egov-ui-framework/ui-config/screens/specs/utils");

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _api = require("egov-ui-framework/ui-utils/api");

var _commons = require("egov-ui-framework/ui-utils/commons");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _jsonpath = require("jsonpath");

var _jsonpath2 = _interopRequireDefault(_jsonpath);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _set = require("lodash/set");

var _set2 = _interopRequireDefault(_set);

var _store = require("ui-redux/store");

var _store2 = _interopRequireDefault(_store);

var _utils2 = require("../ui-config/screens/specs/utils");

var _printJs = require("print-js");

var _printJs2 = _interopRequireDefault(_printJs);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _receiptTransformer = require("egov-tradelicence/ui-config/screens/specs/utils/receiptTransformer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleDeletedCards = function handleDeletedCards(jsonObject, jsonPath, key) {
  var originalArray = (0, _get2.default)(jsonObject, jsonPath, []);
  var modifiedArray = originalArray.filter(function (element) {
    return element.hasOwnProperty(key) || !element.hasOwnProperty("isDeleted");
  });
  modifiedArray = modifiedArray.map(function (element) {
    if (element.hasOwnProperty("isDeleted")) {
      element["isActive"] = false;
    }
    return element;
  });
  (0, _set2.default)(jsonObject, jsonPath, modifiedArray);
};
var getFileUrlFromAPIWS = exports.getFileUrlFromAPIWS = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fileStoreId, tenantId) {
    var queryObject, fileUrl;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryObject = [{ key: "tenantId", value: tenantId || (0, _localStorageUtils.getTenantId)() },
            // { key: "tenantId", value: tenantId || commonConfig.tenantId.length > 2 ? commonConfig.tenantId.split('.')[0] : commonConfig.tenantId },
            { key: "fileStoreIds", value: fileStoreId }];
            _context.prev = 1;
            _context.next = 4;
            return (0, _api.httpRequest)("get", "/filestore/v1/files/url", "", queryObject);

          case 4:
            fileUrl = _context.sent;
            return _context.abrupt("return", fileUrl);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);

            console.log(_context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined, [[1, 8]]);
  }));

  return function getFileUrlFromAPIWS(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getLocaleLabelsforTL = exports.getLocaleLabelsforTL = function getLocaleLabelsforTL(label, labelKey, localizationLabels) {
  if (labelKey) {
    var translatedLabel = (0, _utils2.getTranslatedLabel)(labelKey, localizationLabels);
    if (!translatedLabel || labelKey === translatedLabel) {
      return label;
    } else {
      return translatedLabel;
    }
  } else {
    return label;
  }
};

var findItemInArrayOfObject = exports.findItemInArrayOfObject = function findItemInArrayOfObject(arr, conditionCheckerFn) {
  for (var i = 0; i < arr.length; i++) {
    if (conditionCheckerFn(arr[i])) {
      return arr[i];
    }
  }
};
var getConsumerTransactionSearchResults = exports.getConsumerTransactionSearchResults = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(queryObject, dispatch, tenantId, ownerNo) {
    var response;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context2.next = 4;
            return (0, _api.httpRequest)("post", "/pg-service/transaction/v1/_search?consumerCode=" + ownerNo,
            // "/user/_search?tenantId="+tenantId,
            "", [], {});

          case 4:
            response = _context2.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context2.abrupt("return", response);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context2.t0.message, labelKey: _context2.t0.message }, "error"));
            // throw error;

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[0, 9]]);
  }));

  return function getConsumerTransactionSearchResults(_x3, _x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
var getuserSearchResults = exports.getuserSearchResults = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(queryObject, dispatch, tenantId, ownerNo) {
    var response;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context3.next = 4;
            return (0, _api.httpRequest)("post", "/user/_search?tenantId=" + tenantId, "_search", [], {
              tenantId: tenantId,
              userName: "" + ownerNo
            });

          case 4:
            response = _context3.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context3.abrupt("return", response);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context3.t0.message, labelKey: _context3.t0.message }, "error"));
            // throw error;

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[0, 9]]);
  }));

  return function getuserSearchResults(_x7, _x8, _x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();
var transactionUpdate = exports.transactionUpdate = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(transactionId, gatewayTxnId, dispatch) {
    var response;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context4.next = 4;
            return (0, _api.httpRequest)("post",
            // "/pg-service/transaction/v1/_update?transactionId="+transactionId,
            "/pg-service/transaction/v1/_update?transactionId=" + transactionId + "&gatewayTxnId=" + gatewayTxnId, "", [], {});

          case 4:
            response = _context4.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context4.abrupt("return", response);

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context4.t0.message, labelKey: _context4.t0.message }, "error"));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[0, 9]]);
  }));

  return function transactionUpdate(_x11, _x12, _x13) {
    return _ref4.apply(this, arguments);
  };
}();
var transactionUpdateAxis = exports.transactionUpdateAxis = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(transactionId, razorpay_payment_id, razorpay_order_id, razorpay_signature, dispatch) {
    var response;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context5.next = 4;
            return (0, _api.httpRequest)("post",
            //"/pg-service/transaction/v1/_update?transactionId="+transactionId,
            "/pg-service/transaction/v1/_update?transactionId=" + transactionId + "&razorpay_payment_id=" + razorpay_payment_id + "&razorpay_order_id=" + razorpay_order_id + "&=" + razorpay_signature, "", [], {});

          case 4:
            response = _context5.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context5.abrupt("return", response);

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context5.t0.message, labelKey: _context5.t0.message }, "error"));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, undefined, [[0, 9]]);
  }));

  return function transactionUpdateAxis(_x14, _x15, _x16, _x17, _x18) {
    return _ref5.apply(this, arguments);
  };
}();
var userUnlock = exports.userUnlock = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(user, dispatch) {
    var response;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context6.next = 4;
            return (0, _api.httpRequest)("post", "/user/users/_updatenovalidate?tenantId=ch.chandigarh ", "_updatenovalidate", [], {
              user: user[0]
            });

          case 4:
            response = _context6.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context6.abrupt("return", response);

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context6.t0.message, labelKey: _context6.t0.message }, "error"));

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, undefined, [[0, 9]]);
  }));

  return function userUnlock(_x19, _x20) {
    return _ref6.apply(this, arguments);
  };
}();
var getSearchResults = exports.getSearchResults = function () {
  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(queryObject, dispatch) {
    var response;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            _context7.next = 4;
            return (0, _api.httpRequest)("post", "/firenoc-services/v1/_search", "", queryObject);

          case 4:
            response = _context7.sent;

            _store2.default.dispatch((0, _actions.toggleSpinner)());
            return _context7.abrupt("return", response);

          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](0);

            _store2.default.dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context7.t0.message, labelKey: _context7.t0.message }, "error"));
            throw _context7.t0;

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, undefined, [[0, 9]]);
  }));

  return function getSearchResults(_x21, _x22) {
    return _ref7.apply(this, arguments);
  };
}();

var createUpdateNocApplication = exports.createUpdateNocApplication = function () {
  var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(state, dispatch, status) {
    var nocId, method, payload, tenantId, reduxDocuments, buildings, ownerDocuments, otherDocuments, owners, response, fireNocData;
    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            nocId = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.FireNOCs[0].id");
            method = nocId ? "UPDATE" : "CREATE";
            _context8.prev = 2;
            payload = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "FireNOCs", []);
            tenantId = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "FireNOCs[0].fireNOCDetails.propertyDetails.address.city", (0, _localStorageUtils.getTenantId)());

            (0, _set2.default)(payload[0], "tenantId", tenantId);
            (0, _set2.default)(payload[0], "fireNOCDetails.action", status);

            // Get uploaded documents from redux
            reduxDocuments = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.documentsUploadRedux", {});


            handleDeletedCards(payload[0], "fireNOCDetails.buildings", "id");
            handleDeletedCards(payload[0], "fireNOCDetails.applicantDetails.owners", "id");

            buildings = (0, _get2.default)(payload, "[0].fireNOCDetails.buildings", []);

            buildings.forEach(function (building, index) {
              // GET UOMS FOR THE SELECTED BUILDING TYPE
              var requiredUoms = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.applyScreenMdmsData.firenoc.BuildingType", []).filter(function (buildingType) {
                return buildingType.code === building.usageType;
              });
              requiredUoms = (0, _get2.default)(requiredUoms, "[0].uom", []);
              // GET UNIQUE UOMS LIST INCLUDING THE DEFAULT
              var allUoms = [].concat((0, _toConsumableArray3.default)(new Set([].concat((0, _toConsumableArray3.default)(requiredUoms), ["NO_OF_FLOORS", "NO_OF_BASEMENTS", "PLOT_SIZE", "BUILTUP_AREA", "HEIGHT_OF_BUILDING"]))));
              var finalUoms = [];
              allUoms.forEach(function (uom) {
                var value = (0, _get2.default)(building.uomsMap, uom);
                value && finalUoms.push({
                  code: uom,
                  value: parseInt(value),
                  isActiveUom: requiredUoms.includes(uom) ? true : false,
                  active: true
                });
              });

              // Quick fix to repair old uoms
              var oldUoms = (0, _get2.default)(payload[0], "fireNOCDetails.buildings[" + index + "].uoms", []);
              oldUoms.forEach(function (oldUom, oldUomIndex) {
                (0, _set2.default)(payload[0], "fireNOCDetails.buildings[" + index + "].uoms[" + oldUomIndex + "].isActiveUom", false);
                (0, _set2.default)(payload[0], "fireNOCDetails.buildings[" + index + "].uoms[" + oldUomIndex + "].active", false);
              });
              // End Quick Fix

              (0, _set2.default)(payload[0], "fireNOCDetails.buildings[" + index + "].uoms", [].concat(finalUoms, (0, _toConsumableArray3.default)(oldUoms)));

              // Set building documents
              var uploadedDocs = [];
              _jsonpath2.default.query(reduxDocuments, "$.*").forEach(function (doc) {
                if (doc.documents && doc.documents.length > 0) {
                  if (doc.documentSubCode && doc.documentSubCode.startsWith("BUILDING.BUILDING_PLAN")) {
                    if (doc.documentCode === building.name) {
                      uploadedDocs = [].concat((0, _toConsumableArray3.default)(uploadedDocs), [{
                        tenantId: tenantId,
                        documentType: doc.documentSubCode,
                        fileStoreId: doc.documents[0].fileStoreId
                      }]);
                    }
                  }
                }
              });
              (0, _set2.default)(payload[0], "fireNOCDetails.buildings[" + index + "].applicationDocuments", uploadedDocs);
            });

            // Set owners & other documents
            ownerDocuments = [];
            otherDocuments = [];

            _jsonpath2.default.query(reduxDocuments, "$.*").forEach(function (doc) {
              if (doc.documents && doc.documents.length > 0) {
                if (doc.documentType === "OWNER") {
                  ownerDocuments = [].concat((0, _toConsumableArray3.default)(ownerDocuments), [{
                    tenantId: tenantId,
                    documentType: doc.documentSubCode ? doc.documentSubCode : doc.documentCode,
                    fileStoreId: doc.documents[0].fileStoreId
                  }]);
                } else if (!doc.documentSubCode) {
                  // SKIP BUILDING PLAN DOCS
                  otherDocuments = [].concat((0, _toConsumableArray3.default)(otherDocuments), [{
                    tenantId: tenantId,
                    documentType: doc.documentCode,
                    fileStoreId: doc.documents[0].fileStoreId
                  }]);
                }
              }
            });

            (0, _set2.default)(payload[0], "fireNOCDetails.applicantDetails.additionalDetail.documents", ownerDocuments);
            (0, _set2.default)(payload[0], "fireNOCDetails.additionalDetail.documents", otherDocuments);

            // Set Channel and Financial Year
            process.env.REACT_APP_NAME === "Citizen" ? (0, _set2.default)(payload[0], "fireNOCDetails.channel", "CITIZEN") : (0, _set2.default)(payload[0], "fireNOCDetails.channel", "COUNTER");
            (0, _set2.default)(payload[0], "fireNOCDetails.financialYear", "2019-20");

            // Set Dates to Epoch
            owners = (0, _get2.default)(payload[0], "fireNOCDetails.applicantDetails.owners", []);

            owners.forEach(function (owner, index) {
              (0, _set2.default)(payload[0], "fireNOCDetails.applicantDetails.owners[" + index + "].dob", (0, _utils.convertDateToEpoch)((0, _get2.default)(owner, "dob")));
            });

            response = void 0;

            if (!(method === "CREATE")) {
              _context8.next = 31;
              break;
            }

            _context8.next = 25;
            return (0, _api.httpRequest)("post", "/firenoc-services/v1/_create", "", [], { FireNOCs: payload });

          case 25:
            response = _context8.sent;

            response = furnishNocResponse(response);
            dispatch((0, _actions.prepareFinalObject)("FireNOCs", response.FireNOCs));
            setApplicationNumberBox(state, dispatch);
            _context8.next = 37;
            break;

          case 31:
            if (!(method === "UPDATE")) {
              _context8.next = 37;
              break;
            }

            _context8.next = 34;
            return (0, _api.httpRequest)("post", "/firenoc-services/v1/_update", "", [], { FireNOCs: payload });

          case 34:
            response = _context8.sent;

            response = furnishNocResponse(response);
            dispatch((0, _actions.prepareFinalObject)("FireNOCs", response.FireNOCs));

          case 37:
            return _context8.abrupt("return", { status: "success", message: response });

          case 40:
            _context8.prev = 40;
            _context8.t0 = _context8["catch"](2);

            dispatch((0, _actions.toggleSnackbar)(true, { labelName: _context8.t0.message }, "error"));

            // Revert the changed pfo in case of request failure
            fireNocData = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.FireNOCs", []);

            fireNocData = furnishNocResponse({ FireNOCs: fireNocData });
            dispatch((0, _actions.prepareFinalObject)("FireNOCs", fireNocData.FireNOCs));

            return _context8.abrupt("return", { status: "failure", message: _context8.t0 });

          case 47:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, undefined, [[2, 40]]);
  }));

  return function createUpdateNocApplication(_x23, _x24, _x25) {
    return _ref8.apply(this, arguments);
  };
}();

var prepareDocumentsUploadData = exports.prepareDocumentsUploadData = function prepareDocumentsUploadData(state, dispatch) {
  var documents = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.applyScreenMdmsData.FireNoc.Documents", []);
  documents = documents.filter(function (item) {
    return item.active;
  });
  var documentsContract = [];
  var tempDoc = {};
  documents.forEach(function (doc) {
    var card = {};
    card["code"] = doc.documentType;
    card["title"] = doc.documentType;
    card["cards"] = [];
    tempDoc[doc.documentType] = card;
  });

  documents.forEach(function (doc) {
    // Handle the case for multiple muildings
    if (doc.code === "BUILDING.BUILDING_PLAN" && doc.hasMultipleRows && doc.options) {
      var buildingsData = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.FireNOCs[0].fireNOCDetails.buildings", []);

      buildingsData.forEach(function (building) {
        var card = {};
        card["name"] = building.name;
        card["code"] = doc.code;
        card["hasSubCards"] = true;
        card["subCards"] = [];
        doc.options.forEach(function (subDoc) {
          var subCard = {};
          subCard["name"] = subDoc.code;
          subCard["required"] = subDoc.required ? true : false;
          card.subCards.push(subCard);
        });
        tempDoc[doc.documentType].cards.push(card);
      });
    } else {
      var card = {};
      card["name"] = doc.code;
      card["code"] = doc.code;
      card["required"] = doc.required ? true : false;
      if (doc.hasDropdown && doc.dropdownData) {
        var dropdown = {};
        dropdown.label = "NOC_SELECT_DOC_DD_LABEL";
        dropdown.required = true;
        dropdown.menu = doc.dropdownData.filter(function (item) {
          return item.active;
        });
        dropdown.menu = dropdown.menu.map(function (item) {
          return { code: item.code, label: (0, _commons.getTransformedLocale)(item.code) };
        });
        card["dropdown"] = dropdown;
      }
      tempDoc[doc.documentType].cards.push(card);
    }
  });

  Object.keys(tempDoc).forEach(function (key) {
    documentsContract.push(tempDoc[key]);
  });

  dispatch((0, _actions.prepareFinalObject)("documentsContract", documentsContract));
};

var prepareDocumentsUploadRedux = exports.prepareDocumentsUploadRedux = function prepareDocumentsUploadRedux(state, dispatch) {
  var _props = undefined.props,
      documentsList = _props.documentsList,
      _props$documentsUploa = _props.documentsUploadRedux,
      documentsUploadRedux = _props$documentsUploa === undefined ? {} : _props$documentsUploa,
      prepareFinalObject = _props.prepareFinalObject;

  var index = 0;
  documentsList.forEach(function (docType) {
    docType.cards && docType.cards.forEach(function (card) {
      if (card.subCards) {
        card.subCards.forEach(function (subCard) {
          var oldDocType = (0, _get2.default)(documentsUploadRedux, "[" + index + "].documentType");
          var oldDocCode = (0, _get2.default)(documentsUploadRedux, "[" + index + "].documentCode");
          var oldDocSubCode = (0, _get2.default)(documentsUploadRedux, "[" + index + "].documentSubCode");
          if (oldDocType != docType.code || oldDocCode != card.name || oldDocSubCode != subCard.name) {
            documentsUploadRedux[index] = {
              documentType: docType.code,
              documentCode: card.name,
              documentSubCode: subCard.name
            };
          }
          index++;
        });
      } else {
        var oldDocType = (0, _get2.default)(documentsUploadRedux, "[" + index + "].documentType");
        var oldDocCode = (0, _get2.default)(documentsUploadRedux, "[" + index + "].documentCode");
        if (oldDocType != docType.code || oldDocCode != card.name) {
          documentsUploadRedux[index] = {
            documentType: docType.code,
            documentCode: card.name,
            isDocumentRequired: card.required,
            isDocumentTypeRequired: card.dropdown ? card.dropdown.required : false
          };
        }
      }
      index++;
    });
  });
  prepareFinalObject("documentsUploadRedux", documentsUploadRedux);
};

var furnishNocResponse = exports.furnishNocResponse = function furnishNocResponse(response) {
  // Handle applicant ownership dependent dropdowns
  var ownershipType = (0, _get2.default)(response, "FireNOCs[0].fireNOCDetails.applicantDetails.ownerShipType");
  (0, _set2.default)(response, "FireNOCs[0].fireNOCDetails.applicantDetails.ownerShipMajorType", ownershipType == undefined ? "SINGLE" : ownershipType.split(".")[0]);

  // Prepare UOMS and Usage Type Dropdowns in required format
  var buildings = (0, _get2.default)(response, "FireNOCs[0].fireNOCDetails.buildings", []);
  buildings.forEach(function (building, index) {
    var uoms = (0, _get2.default)(building, "uoms", []);
    var uomMap = {};
    uoms.forEach(function (uom) {
      uomMap[uom.code] = "" + uom.value;
    });
    (0, _set2.default)(response, "FireNOCs[0].fireNOCDetails.buildings[" + index + "].uomsMap", uomMap);

    var usageType = (0, _get2.default)(building, "usageType");
    (0, _set2.default)(response, "FireNOCs[0].fireNOCDetails.buildings[" + index + "].usageTypeMajor", usageType == undefined ? "" : usageType.split(".")[0]);
  });

  return response;
};

var setApplicationNumberBox = exports.setApplicationNumberBox = function setApplicationNumberBox(state, dispatch, applicationNo) {
  if (!applicationNo) {
    applicationNo = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject.FireNOCs[0].fireNOCDetails.applicationNumber", null);
  }

  if (applicationNo) {
    dispatch((0, _actions.handleScreenConfigurationFieldChange)("apply", "components.div.children.headerDiv.children.header.children.applicationNumber", "visible", true));
    dispatch((0, _actions.handleScreenConfigurationFieldChange)("apply", "components.div.children.headerDiv.children.header.children.applicationNumber", "props.number", applicationNo));
  }
};
var GetMdmsNameBycode = exports.GetMdmsNameBycode = function GetMdmsNameBycode(state, dispatch, jsonpath, code) {
  //Material
  var Obj = (0, _get2.default)(state, "screenConfiguration.preparedFinalObject." + jsonpath, []);
  var Name = code;
  Obj = Obj.filter(function (x) {
    return x.code === code;
  });
  if (Obj && Obj[0]) Name = Obj[0].name;
  return Name;
};
var downloadReceiptFromFilestoreID = exports.downloadReceiptFromFilestoreID = function downloadReceiptFromFilestoreID(fileStoreId, mode, tenantId) {
  // getFileUrlFromAPIWS(fileStoreId,tenantId).then(async(fileRes) => {
  (0, _commons.getFileUrlFromAPI)(fileStoreId, tenantId).then(function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(fileRes) {
      var win, response, file, fileURL, myWindow;
      return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (!(mode === 'download')) {
                _context9.next = 5;
                break;
              }

              win = window.open(fileRes[fileStoreId], '_blank');

              if (win) {
                win.focus();
              }
              _context9.next = 13;
              break;

            case 5:
              _context9.next = 7;
              return _axios2.default.get(fileRes[fileStoreId], {
                //responseType: "blob",
                responseType: "arraybuffer",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/pdf"
                }
              });

            case 7:
              response = _context9.sent;

              console.log("responseData---", response);
              file = new Blob([response.data], { type: "application/pdf" });
              fileURL = URL.createObjectURL(file);
              myWindow = window.open(fileURL);

              if (myWindow != undefined) {
                myWindow.addEventListener("load", function (event) {
                  myWindow.focus();
                  myWindow.print();
                });
              }

            case 13:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, undefined);
    }));

    return function (_x26) {
      return _ref9.apply(this, arguments);
    };
  }());
};
var epochToYmdDate = exports.epochToYmdDate = function epochToYmdDate(et) {
  if (!et) return null;
  if (typeof et === "string") return et;
  var d = new Date(et),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};
var download = function () {
  var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(state, dispatch) {
    var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "download";

    var businessServiceInfo, businessServicewsbillreceipt, bservice, WNSConfigName_, billGeneration, receiptQueryString, FETCHRECEIPT, DOWNLOADRECEIPT, keyvalue, KeytenantId, _WNSConfigName_;

    return _regenerator2.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            businessServiceInfo = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "businessServiceInfo", {});
            businessServicewsbillreceipt = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "businessServicewsbillreceipt", '');
            bservice = '';
            WNSConfigName_ = WNSConfigName();

            bservice = WNSConfigName_.ONE_TIME_FEE_WS;
            if (businessServicewsbillreceipt === null || businessServicewsbillreceipt === '') {
              businessServicewsbillreceipt = (0, _commons.getQueryArg)(window.location.href, "businessService");
            }
            billGeneration = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "billGeneration", []);

            console.log(businessServiceInfo);
            receiptQueryString = [{ key: "receiptNumbers", value: (0, _commons.getQueryArg)(window.location.href, "receiptNumber") }, { key: "tenantId", value: (0, _commons.getQueryArg)(window.location.href, "tenantId") }];

            if (billGeneration.length === 0) {
              receiptQueryString = [{ key: "consumerCodes", value: (0, _commons.getQueryArg)(window.location.href, "consumerCode") }, { key: "tenantId", value: (0, _commons.getQueryArg)(window.location.href, "tenantId") }];
            }
            FETCHRECEIPT = {
              GET: {
                URL: "/collection-services/payments/_search",
                ACTION: "_get"
              }
            };
            DOWNLOADRECEIPT = {
              GET: {
                URL: "/pdf-service/v1/_create",
                ACTION: "_get"
              }
            };

            try {
              keyvalue = 'consolidatedreceipt';
              KeytenantId = receiptQueryString[1].value;

              if (process.env.REACT_APP_NAME === "Citizen") {
                KeytenantId = receiptQueryString[1].value.split('.')[0];
              }
              if (businessServicewsbillreceipt === '' || businessServicewsbillreceipt === null) {
                businessServicewsbillreceipt = (0, _commons.getQueryArg)(window.location.href, "consumerCode");
                _WNSConfigName_ = WNSConfigName();

                bservice = _WNSConfigName_.ONE_TIME_FEE_WS;
              }

              //if()
              if (businessServicewsbillreceipt === bservice || businessServicewsbillreceipt === WNSConfigName_.ONE_TIME_FEE_SW || businessServicewsbillreceipt.includes("SW") || businessServicewsbillreceipt.includes("WS")) {
                keyvalue = 'ws-bill-receipt';
              } else if (businessServicewsbillreceipt === 'WS') {
                keyvalue = 'ws-bill';
              } else if (businessServiceInfo.code.includes("CTL")) {
                keyvalue = 'tl-receipt';
                //KeytenantId =receiptQueryString[1].value
                (0, _receiptTransformer.loadReceiptGenerationData)((0, _commons.getQueryArg)(window.location.href, "consumerCode"), (0, _commons.getQueryArg)(window.location.href, "tenantId"), state, dispatch);
              } else {
                KeytenantId = receiptQueryString[1].value.split('.')[0];
              }
              try {
                (0, _api.httpRequest)("post", FETCHRECEIPT.GET.URL, FETCHRECEIPT.GET.ACTION, receiptQueryString).then(function (payloadReceiptDetails) {
                  var queryStr = [{ key: "key", value: keyvalue }, { key: "tenantId", value: KeytenantId }];
                  if (payloadReceiptDetails && payloadReceiptDetails.Payments && payloadReceiptDetails.Payments.length == 0) {
                    console.log("Could not find any receipts");
                    dispatch((0, _actions.toggleSnackbar)(true, { labelName: "Could not find any receipts", labelKey: "Could not find any receipts" }, "warning"));
                    return;
                  }
                  if (businessServicewsbillreceipt === 'WS') {
                    (0, _api.httpRequest)("post", DOWNLOADRECEIPT.GET.URL, DOWNLOADRECEIPT.GET.ACTION, queryStr, { billGeneration: billGeneration }, { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                      res.filestoreIds[0];
                      if (res && res.filestoreIds && res.filestoreIds.length > 0) {
                        res.filestoreIds.map(function (fileStoreId) {
                          downloadReceiptFromFilestoreID(fileStoreId, "download", KeytenantId);
                        });
                      } else {
                        console.log("Error In Receipt Download");
                      }
                    });
                  } else if (businessServicewsbillreceipt === bservice || businessServicewsbillreceipt === WNSConfigName_.ONE_TIME_FEE_SW || businessServicewsbillreceipt.includes("SW") || businessServicewsbillreceipt.includes("WS")) {
                    var paymentReceiptDate = 0;
                    var paidAmount = 0;
                    var dueAmount = 0;
                    if (payloadReceiptDetails && payloadReceiptDetails.Payments && payloadReceiptDetails.Payments.length > 0) {
                      paymentReceiptDate = epochToYmdDate((0, _get2.default)(payloadReceiptDetails, "Payments[0].transactionDate", ''));
                      paidAmount = (0, _get2.default)(payloadReceiptDetails, "Payments[0].paymentDetails[0].totalAmountPaid", '');
                      dueAmount = (0, _get2.default)(payloadReceiptDetails, "Payments[0].paymentDetails[0].totalDue", '');
                    }
                    // call get api to set  WaterConnection details
                    var applicationNumber = (0, _commons.getQueryArg)(window.location.href, "consumerCode");
                    var queryObject = [{ key: "tenantId", value: (0, _commons.getQueryArg)(window.location.href, "tenantId") }, { key: "applicationNumber", value: applicationNumber }];
                    var div = '';
                    var subDiv = '';
                    var activityType = '';
                    var applicantName = '';
                    var applicantAddress = '';
                    var houseNo = '';
                    var plotnumber = '';
                    var sector = '';
                    var connectionNumber = '';
                    if (applicationNumber.includes("WS")) {
                      //   const response = await httpRequest(
                      //     "post",
                      //     "/ws-services/wc/_search",
                      //     "_search",
                      //     queryObject

                      // );
                      try {
                        var wc_search = {
                          GET: {
                            URL: "/ws-services/wc/_search",
                            ACTION: "_search"
                          }
                        };
                        (0, _api.httpRequest)("post", wc_search.GET.URL, wc_search.GET.ACTION, queryObject, [], { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                          res.WaterConnection[0];
                          if (res && res.WaterConnection && res.WaterConnection.length > 0) {
                            var queryObjectP = [{ key: "tenantId", value: (0, _commons.getQueryArg)(window.location.href, "tenantId") }, { key: "uuids", value: res.WaterConnection[0].propertyId }];
                            var wc_searchPropety = {
                              GET: {
                                URL: "/property-services/property/_search",
                                ACTION: "_search"
                              }
                            };
                            (0, _api.httpRequest)("post", wc_searchPropety.GET.URL, wc_searchPropety.GET.ACTION, queryObjectP, [], { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (resp) {
                              div = (0, _get2.default)(res, "WaterConnection[0].div", '');
                              subDiv = (0, _get2.default)(res, "WaterConnection[0].subdiv", '');
                              activityType = (0, _get2.default)(res, "WaterConnection[0].activityType", '');
                              applicantName = (0, _get2.default)(res, "WaterConnection[0].connectionHolders[0].name", '');
                              applicantAddress = (0, _get2.default)(res, "WaterConnection[0].connectionHolders[0].correspondenceAddress", '');
                              connectionNumber = (0, _get2.default)(res, "WaterConnection[0].connectionNo", '');
                              var waterApplicationList = (0, _get2.default)(res, "WaterConnection[0].waterApplicationList", []);
                              var connectionHolders = (0, _get2.default)(res, "WaterConnection[0].connectionHolders", []);
                              if (connectionNumber !== null) {
                                if (connectionNumber.length < 14) {
                                  connectionNumber = 'Account Number Generation Under Process';
                                }
                              } else {
                                connectionNumber = 'Account Number Generation Under Process';
                              }
                              if (connectionHolders.length > 1) {
                                waterApplicationList = waterApplicationList.filter(function (x) {
                                  return x.applicationNo === applicationNumber;
                                });
                                connectionHolders = connectionHolders.filter(function (x) {
                                  return x.ws_application_id === waterApplicationList[0].id;
                                });
                                if (connectionHolders && connectionHolders[0]) {
                                  applicantName = connectionHolders[0].name;
                                  // applicantName = connectionHolders[0].name
                                }
                              }
                              if (resp && resp.Properties && resp.Properties.length > 0) {
                                plotnumber = (0, _get2.default)(resp.Properties[0], "address.doorNo", '');
                                houseNo = (0, _get2.default)(resp.Properties[0], "address.plotNo", '');
                                if (houseNo === null || houseNo === undefined) {
                                  houseNo = "NA";
                                }
                                sector = (0, _get2.default)(resp.Properties[0], "address.locality.name", '');
                                if (sector === undefined || sector === null) {
                                  sector = (0, _get2.default)(resp.Properties[0], "address.locality.code", '');
                                  sector = GetMdmsNameBycode(state, dispatch, "searchPreviewScreenMdmsData.ws-services-masters.sectorList", sector);
                                }
                                applicantAddress = plotnumber + "," + houseNo + "," + sector;
                                // applicantAddress = `Plot number-${plotnumber},House number-${houseNo},Locality-${sector}`
                                applicantAddress = "Plot No/House No-" + plotnumber + ",Locality-" + sector;
                              }
                              // set activityType APPLY_FOR_TEMPORARY_CONNECTION_BILLING
                              switch (activityType) {
                                case "APPLY_FOR_TEMPORARY_CONNECTION":
                                case "APPLY_FOR_TEMPORARY_CONNECTION_BILLING":
                                  activityType = 'Temporary Water Connection';
                                  break;
                                case "NEW_WS_CONNECTION":
                                  activityType = 'Regular Water Connection';
                                  break;
                                case "REGULARWSCONNECTION":
                                  activityType = 'Regular Water Connection';
                                  break;
                                case "APPLY_FOR_TEMPORARY_REGULAR_CONNECTION":
                                  activityType = 'Temporary Regular Water Connection';
                                  break;
                                case "TEMPORARY_WSCONNECTION":
                                case "APPLY_FOR_TEMPORARY_CONNECTION":
                                case "APPLY_FOR_TEMPORARY_CONNECTION_BILLING":
                                  activityType = 'Temporary Water Connection';
                                  break;
                                case "WS_TUBEWELL":
                                  activityType = 'New Tubewell Connection';
                                  break;
                                case "WS_TEMP_TEMP":
                                case "APPLY_FOR_TEMPORARY_TEMPORARY_CONNECTION":
                                  activityType = 'Temporary to Temporary Conversion';
                                  break;
                                case "WS_TEMP_REGULAR":
                                case "APPLY_FOR_TEMPORARY_REGULAR_CONNECTION":
                                  activityType = 'Temporary to Regular Conversion';
                                  break;
                                case "WS_DISCONNECTION":
                                case "PERMANENT_DISCONNECTION":
                                  activityType = 'Permanent Disconnection';
                                  break;
                                case "WS_TEMP_DISCONNECTION":
                                case "TEMPORARY_DISCONNECTION":
                                  activityType = 'Temporary Disconnection';
                                  break;
                                case "WS_RENAME":
                                case "UPDATE_CONNECTION_HOLDER_INFO":
                                  activityType = 'Update Connection Holder Information';
                                  {
                                    var index = 0;
                                    if (res.WaterConnection[0].connectionHolders && res.WaterConnection[0].connectionHolders.length > 1) {
                                      var id = res.WaterConnection[0].waterApplication.id;
                                      //[0].waterApplication
                                      var _connectionHolders = res.WaterConnection[0].connectionHolders.filter(function (x) {
                                        return x.ws_application_id === id;
                                      });
                                      if (_connectionHolders && _connectionHolders[0]) {
                                        applicantName = _connectionHolders[0].proposedName;
                                      }
                                    } else {
                                      applicantName = (0, _get2.default)(res, "WaterConnection[0].connectionHolders[" + index + "].proposedName", '');
                                    }
                                  }
                                  break;
                                case "WS_METER_UPDATE":
                                case "UPDATE_METER_INFO":
                                  activityType = 'Meter Update';
                                  break;
                                case "APPLY_FOR_METER_TESTING":
                                case "WS_METER_TESTING":
                                  activityType = 'Meter Testing';
                                  break;
                                case "WS_CONVERSION":
                                case "CONNECTION_CONVERSION":
                                  activityType = 'Tariff Change';
                                  break;
                                case "WS_REACTIVATE":
                                case "REACTIVATE_CONNECTION":
                                  activityType = 'Reactive Connection';
                                  break;
                                case "APPLY_FOR_TEMPORARY_TEMPORARY_CONNECTION":
                                  activityType = 'Temporary to Temporary Conversion';
                                  break;

                              }
                              var billGeneration_ = [{

                                div: div,
                                subDiv: subDiv,
                                applicationNumber: applicationNumber,
                                connectionNumber: connectionNumber,
                                receiptNumber: (0, _commons.getQueryArg)(window.location.href, "receiptNumber"),
                                activityType: activityType,
                                applicantName: applicantName,
                                applicantAddress: applicantAddress,
                                paymentReceiptDate: paymentReceiptDate,
                                dueAmount: dueAmount,
                                paidAmount: paidAmount,
                                status: 'Payment complete'
                              }];

                              (0, _api.httpRequest)("post", DOWNLOADRECEIPT.GET.URL, DOWNLOADRECEIPT.GET.ACTION, queryStr, { WSReceiptRequest: billGeneration_ }, { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                                res.filestoreIds[0];
                                if (res && res.filestoreIds && res.filestoreIds.length > 0) {
                                  res.filestoreIds.map(function (fileStoreId) {
                                    downloadReceiptFromFilestoreID(fileStoreId, "download", KeytenantId);
                                  });
                                } else {
                                  console.log("Error In Receipt Download");
                                }
                              });
                            });
                          } else {
                            console.log("Error In Receipt Download");
                          }
                        });
                        //
                      } catch (error) {
                        dispatch((0, _actions.toggleSnackbar)(true, { labelName: error.message, labelKey: error.message }, "error"));
                        console.log(error);
                      }
                    } else if (applicationNumber.includes("SW")) {

                      var wswc_search = {
                        GET: {
                          URL: "/sw-services/swc/_search",
                          ACTION: "_search"
                        }
                      };
                      (0, _api.httpRequest)("post", wswc_search.GET.URL, wswc_search.GET.ACTION, queryObject, [], { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                        res.SewerageConnections[0];
                        if (res && res.SewerageConnections && res.SewerageConnections.length > 0) {
                          var queryObjectP = [{ key: "tenantId", value: (0, _commons.getQueryArg)(window.location.href, "tenantId") }, { key: "uuids", value: res.SewerageConnections[0].propertyId }];
                          var wc_searchPropety = {
                            GET: {
                              URL: "/property-services/property/_search",
                              ACTION: "_search"
                            }
                          };
                          (0, _api.httpRequest)("post", wc_searchPropety.GET.URL, wc_searchPropety.GET.ACTION, queryObjectP, [], { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (resp) {
                            div = (0, _get2.default)(res, "SewerageConnections[0].div", '');
                            subDiv = (0, _get2.default)(res, "SewerageConnections[0].subdiv", '');
                            activityType = (0, _get2.default)(res, "SewerageConnections[0].activityType", '');
                            applicantName = (0, _get2.default)(res, "SewerageConnections[0].connectionHolders[0].name", '');
                            applicantAddress = (0, _get2.default)(res, "SewerageConnections[0].connectionHolders[0].correspondenceAddress", '');

                            connectionNumber = (0, _get2.default)(res, "SewerageConnections[0].connectionNo", '');

                            if (resp && resp.Properties && resp.Properties.length > 0) {
                              plotnumber = (0, _get2.default)(resp.Properties[0], "address.doorNo", '');
                              houseNo = (0, _get2.default)(resp.Properties[0], "address.plotNo", '');
                              if (houseNo === null || houseNo === undefined) {
                                houseNo = "NA";
                              }
                              sector = (0, _get2.default)(resp.Properties[0], "address.locality.name", '');
                              if (sector === undefined || sector === null) {
                                sector = (0, _get2.default)(resp.Properties[0], "address.locality.code", '');
                                sector = GetMdmsNameBycode(state, dispatch, "searchPreviewScreenMdmsData.ws-services-masters.swSectorList", sector);
                              }
                              applicantAddress = plotnumber + "," + houseNo + "," + sector;
                              //applicantAddress = `Plot number-${plotnumber},House number-${houseNo},Locality-${sector}`
                              applicantAddress = "Plot No/House No-" + plotnumber + ",Locality-" + sector;
                            }
                            if (activityType === null) {
                              activityType = "Sewarage Connection";
                            }
                            var billGeneration_ = [{

                              div: div,
                              subDiv: subDiv,
                              applicationNumber: applicationNumber,
                              connectionNumber: connectionNumber,
                              receiptNumber: (0, _commons.getQueryArg)(window.location.href, "receiptNumber"),
                              activityType: activityType,
                              applicantName: applicantName,
                              applicantAddress: applicantAddress,
                              paymentReceiptDate: paymentReceiptDate,
                              dueAmount: dueAmount,
                              paidAmount: paidAmount,
                              status: 'Payment complete'
                            }];
                            (0, _api.httpRequest)("post", DOWNLOADRECEIPT.GET.URL, DOWNLOADRECEIPT.GET.ACTION, queryStr, { WSReceiptRequest: billGeneration_ }, { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                              res.filestoreIds[0];
                              if (res && res.filestoreIds && res.filestoreIds.length > 0) {
                                res.filestoreIds.map(function (fileStoreId) {
                                  downloadReceiptFromFilestoreID(fileStoreId, "download", KeytenantId);
                                });
                              } else {
                                console.log("Error In Receipt Download");
                              }
                            });
                          });
                        } else {
                          console.log("Error In Receipt Download");
                        }
                      });
                    }
                  } else if (businessServiceInfo.code.includes('CTL')) {
                    var data = function data() {
                      var data1 = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "applicationDataForReceipt", {});
                      var data2 = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "receiptDataForReceipt", {});
                      var data3 = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "mdmsDataForReceipt", {});
                      var data4 = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "userDataForReceipt", {});
                      return (0, _extends3.default)({}, data1, data2, data3, data4);
                    };
                    var Licenses = state.screenConfiguration.preparedFinalObject.Licenses;
                    var Payments = payloadReceiptDetails.Payments;
                    var billAccountDetails = Payments[0].paymentDetails[0].bill.billDetails[0].billAccountDetails;

                    billAccountDetails = billAccountDetails.map(function (_ref11) {
                      var taxHeadCode = _ref11.taxHeadCode,
                          rest = (0, _objectWithoutProperties3.default)(_ref11, ["taxHeadCode"]);
                      return (0, _extends3.default)({}, rest, {
                        taxHeadCode: taxHeadCode.includes("_FEE") ? "TL_FEE" : taxHeadCode.includes("_PENALTY") ? "TL_TIME_PENALTY" : taxHeadCode.includes("_TAX") ? "TL_TAX" : taxHeadCode.includes("_ROUNDOFF") ? "TL_ROUNDOFF" : taxHeadCode.includes("REHRI_REGISTRATION_CHARGES") ? "TL_CHARGES" : taxHeadCode
                      });
                    });
                    Payments = [(0, _extends3.default)({}, Payments[0], { paymentDetails: [(0, _extends3.default)({}, Payments[0].paymentDetails[0], { bill: (0, _extends3.default)({}, Payments[0].paymentDetails[0].bill, { billDetails: [(0, _extends3.default)({}, Payments[0].paymentDetails[0].bill.billDetails[0], { billAccountDetails: billAccountDetails })] }) })] })];

                    var data1 = data();
                    var generateBy = JSON.parse((0, _localStorageUtils.getUserInfo)()).name;
                    (0, _api.httpRequest)("post", DOWNLOADRECEIPT.GET.URL, DOWNLOADRECEIPT.GET.ACTION, queryStr, { Payments: Payments, Licenses: Licenses, data1: data1, generateBy: generateBy }, { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                      res.filestoreIds[0];
                      if (res && res.filestoreIds && res.filestoreIds.length > 0) {
                        res.filestoreIds.map(function (fileStoreId) {
                          downloadReceiptFromFilestoreID(fileStoreId, "download", KeytenantId);
                        });
                      } else {
                        console.log("Error In Receipt Download");
                      }
                    });
                  } else {
                    (0, _api.httpRequest)("post", DOWNLOADRECEIPT.GET.URL, DOWNLOADRECEIPT.GET.ACTION, queryStr, { Payments: payloadReceiptDetails.Payments }, { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                      res.filestoreIds[0];
                      if (res && res.filestoreIds && res.filestoreIds.length > 0) {
                        res.filestoreIds.map(function (fileStoreId) {
                          downloadReceiptFromFilestoreID(fileStoreId, "download");
                        });
                      } else {
                        console.log("Error In Receipt Download");
                      }
                    });
                  }
                });
              } catch (error) {
                dispatch((0, _actions.toggleSnackbar)(true, { labelName: error.message, labelKey: error.message }, "error"));
                console.log(error);
              }
            } catch (exception) {
              alert('Some Error Occured while downloading Receipt!');
            }

          case 13:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, undefined);
  }));

  return function download(_x27, _x28) {
    return _ref10.apply(this, arguments);
  };
}();
//downloadprint
exports.download = download;
var downloadprint = function () {
  var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(state, dispatch) {
    var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "download";

    var businessServiceInfo, businessServicewsbillreceipt, bservice, WNSConfigName_, billGeneration, receiptQueryString, FETCHRECEIPT, DOWNLOADRECEIPT, keyvalue, KeytenantId, _WNSConfigName_2;

    return _regenerator2.default.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            businessServiceInfo = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "businessServiceInfo", {});
            businessServicewsbillreceipt = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "businessServicewsbillreceipt", '');
            bservice = '';
            WNSConfigName_ = WNSConfigName();

            bservice = WNSConfigName_.ONE_TIME_FEE_WS;
            if (businessServicewsbillreceipt === null || businessServicewsbillreceipt === '') {
              businessServicewsbillreceipt = (0, _commons.getQueryArg)(window.location.href, "businessService");
            }
            billGeneration = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "billGeneration", []);

            console.log(businessServiceInfo);
            receiptQueryString = [{ key: "receiptNumbers", value: (0, _commons.getQueryArg)(window.location.href, "receiptNumber") }, { key: "tenantId", value: (0, _commons.getQueryArg)(window.location.href, "tenantId") }];

            if (billGeneration.length === 0) {
              receiptQueryString = [{ key: "consumerCodes", value: (0, _commons.getQueryArg)(window.location.href, "consumerCode") }, { key: "tenantId", value: (0, _commons.getQueryArg)(window.location.href, "tenantId") }];
            }
            FETCHRECEIPT = {
              GET: {
                URL: "/collection-services/payments/_search",
                ACTION: "_get"
              }
            };
            DOWNLOADRECEIPT = {
              GET: {
                URL: "/pdf-service/v1/_create",
                ACTION: "_get"
              }
            };

            try {
              keyvalue = 'consolidatedreceipt';
              KeytenantId = receiptQueryString[1].value;

              if (process.env.REACT_APP_NAME === "Citizen") {
                KeytenantId = receiptQueryString[1].value.split('.')[0];
              }
              if (businessServicewsbillreceipt === '' || businessServicewsbillreceipt === null) {
                businessServicewsbillreceipt = (0, _commons.getQueryArg)(window.location.href, "consumerCode");
                _WNSConfigName_2 = WNSConfigName();

                bservice = _WNSConfigName_2.ONE_TIME_FEE_WS;
              }

              //if()
              if (businessServicewsbillreceipt === bservice || businessServicewsbillreceipt === WNSConfigName_.ONE_TIME_FEE_SW || businessServicewsbillreceipt.includes("SW") || businessServicewsbillreceipt.includes("WS")) {
                keyvalue = 'ws-bill-receipt';
              } else if (businessServicewsbillreceipt === 'WS') {
                keyvalue = 'ws-bill';
              } else if (businessServiceInfo.code.includes("CTL")) {
                keyvalue = 'tl-receipt';
                //KeytenantId =receiptQueryString[1].value
                (0, _receiptTransformer.loadReceiptGenerationData)((0, _commons.getQueryArg)(window.location.href, "consumerCode"), (0, _commons.getQueryArg)(window.location.href, "tenantId"), state, dispatch);
              } else {
                KeytenantId = receiptQueryString[1].value.split('.')[0];
              }
              try {
                (0, _api.httpRequest)("post", FETCHRECEIPT.GET.URL, FETCHRECEIPT.GET.ACTION, receiptQueryString).then(function (payloadReceiptDetails) {
                  var queryStr = [{ key: "key", value: keyvalue }, { key: "tenantId", value: KeytenantId }];
                  if (payloadReceiptDetails && payloadReceiptDetails.Payments && payloadReceiptDetails.Payments.length == 0) {
                    console.log("Could not find any receipts");
                    dispatch((0, _actions.toggleSnackbar)(true, { labelName: "Could not find any receipts", labelKey: "Could not find any receipts" }, "warning"));
                    return;
                  }
                  if (businessServicewsbillreceipt === 'WS') {
                    (0, _api.httpRequest)("post", DOWNLOADRECEIPT.GET.URL, DOWNLOADRECEIPT.GET.ACTION, queryStr, { billGeneration: billGeneration }, { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                      res.filestoreIds[0];
                      if (res && res.filestoreIds && res.filestoreIds.length > 0) {
                        res.filestoreIds.map(function (fileStoreId) {
                          downloadReceiptFromFilestoreID(fileStoreId, "download", KeytenantId);
                        });
                      } else {
                        console.log("Error In Receipt Download");
                      }
                    });
                  } else if (businessServicewsbillreceipt === bservice || businessServicewsbillreceipt === WNSConfigName_.ONE_TIME_FEE_SW || businessServicewsbillreceipt.includes("SW") || businessServicewsbillreceipt.includes("WS")) {
                    var paymentReceiptDate = 0;
                    var paidAmount = 0;
                    var dueAmount = 0;
                    if (payloadReceiptDetails && payloadReceiptDetails.Payments && payloadReceiptDetails.Payments.length > 0) {
                      paymentReceiptDate = epochToYmdDate((0, _get2.default)(payloadReceiptDetails, "Payments[0].transactionDate", ''));
                      paidAmount = (0, _get2.default)(payloadReceiptDetails, "Payments[0].paymentDetails[0].totalAmountPaid", '');
                      dueAmount = (0, _get2.default)(payloadReceiptDetails, "Payments[0].paymentDetails[0].totalDue", '');
                    }
                    // call get api to set  WaterConnection details
                    var applicationNumber = (0, _commons.getQueryArg)(window.location.href, "consumerCode");
                    var queryObject = [{ key: "tenantId", value: (0, _commons.getQueryArg)(window.location.href, "tenantId") }, { key: "applicationNumber", value: applicationNumber }];
                    var div = '';
                    var subDiv = '';
                    var activityType = '';
                    var applicantName = '';
                    var applicantAddress = '';
                    var houseNo = '';
                    var plotnumber = '';
                    var sector = '';
                    var connectionNumber = '';
                    if (applicationNumber.includes("WS")) {
                      //   const response = await httpRequest(
                      //     "post",
                      //     "/ws-services/wc/_search",
                      //     "_search",
                      //     queryObject

                      // );
                      try {
                        var wc_search = {
                          GET: {
                            URL: "/ws-services/wc/_search",
                            ACTION: "_search"
                          }
                        };
                        (0, _api.httpRequest)("post", wc_search.GET.URL, wc_search.GET.ACTION, queryObject, [], { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                          res.WaterConnection[0];
                          if (res && res.WaterConnection && res.WaterConnection.length > 0) {
                            var queryObjectP = [{ key: "tenantId", value: (0, _commons.getQueryArg)(window.location.href, "tenantId") }, { key: "uuids", value: res.WaterConnection[0].propertyId }];
                            var wc_searchPropety = {
                              GET: {
                                URL: "/property-services/property/_search",
                                ACTION: "_search"
                              }
                            };
                            (0, _api.httpRequest)("post", wc_searchPropety.GET.URL, wc_searchPropety.GET.ACTION, queryObjectP, [], { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (resp) {
                              div = (0, _get2.default)(res, "WaterConnection[0].div", '');
                              subDiv = (0, _get2.default)(res, "WaterConnection[0].subdiv", '');
                              activityType = (0, _get2.default)(res, "WaterConnection[0].activityType", '');
                              applicantName = (0, _get2.default)(res, "WaterConnection[0].connectionHolders[0].name", '');
                              applicantAddress = (0, _get2.default)(res, "WaterConnection[0].connectionHolders[0].correspondenceAddress", '');

                              if (resp && resp.Properties && resp.Properties.length > 0) {
                                plotnumber = (0, _get2.default)(resp.Properties[0], "address.doorNo", '');
                                houseNo = (0, _get2.default)(resp.Properties[0], "address.plotNo", '');
                                if (houseNo === null || houseNo === undefined) {
                                  houseNo = "NA";
                                }
                                sector = (0, _get2.default)(resp.Properties[0], "address.locality.name", '');
                                if (sector === undefined || sector === null) {
                                  sector = (0, _get2.default)(resp.Properties[0], "address.locality.code", '');
                                  sector = GetMdmsNameBycode(state, dispatch, "searchPreviewScreenMdmsData.ws-services-masters.sectorList", sector);
                                }
                                applicantAddress = plotnumber + "," + houseNo + "," + sector;
                                // applicantAddress = `Plot number-${plotnumber},House number-${houseNo},Locality-${sector}`
                                applicantAddress = "Plot No/House No-" + plotnumber + ",Locality-" + sector;
                              }
                              // set activityType 
                              switch (activityType) {
                                case "APPLY_FOR_TEMPORARY_CONNECTION":
                                case "APPLY_FOR_TEMPORARY_CONNECTION_BILLING":
                                  activityType = 'Temporary Water Connection';
                                  break;
                                case "NEW_WS_CONNECTION":
                                  activityType = 'Regular Water Connection';
                                  break;
                                case "REGULARWSCONNECTION":
                                  activityType = 'Regular Water Connection';
                                  break;
                                case "APPLY_FOR_TEMPORARY_REGULAR_CONNECTION":
                                  activityType = 'Temporary Regular Water Connection';
                                  break;
                                case "TEMPORARY_WSCONNECTION":
                                case "APPLY_FOR_TEMPORARY_CONNECTION":
                                case "APPLY_FOR_TEMPORARY_CONNECTION_BILLING":
                                  activityType = 'Temporary Water Connection';
                                  break;
                                case "WS_TUBEWELL":
                                  activityType = 'New Tubewell Connection';
                                  break;
                                case "WS_TEMP_TEMP":
                                case "APPLY_FOR_TEMPORARY_TEMPORARY_CONNECTION":
                                  activityType = 'Temporary to Temporary Conversion';
                                  break;
                                case "WS_TEMP_REGULAR":
                                case "APPLY_FOR_TEMPORARY_REGULAR_CONNECTION":
                                  activityType = 'Temporary to Regular Conversion';
                                  break;
                                case "WS_DISCONNECTION":
                                case "PERMANENT_DISCONNECTION":
                                  activityType = 'Permanent Disconnection';
                                  break;
                                case "WS_TEMP_DISCONNECTION":
                                case "TEMPORARY_DISCONNECTION":
                                  activityType = 'Temporary Disconnection';
                                  break;
                                case "WS_RENAME":
                                case "UPDATE_CONNECTION_HOLDER_INFO":
                                  activityType = 'Update Connection Holder Information';
                                  {
                                    //res.WaterConnection[0].connectionHolders
                                    var index = 0;
                                    if (res.WaterConnection[0].connectionHolders && res.WaterConnection[0].connectionHolders.length > 1) {
                                      var id = res.WaterConnection[0].waterApplication.id;
                                      var connectionHolders = res.WaterConnection[0].connectionHolders.filter(function (x) {
                                        return x.ws_application_id === id;
                                      });
                                      // let index = res.WaterConnection[0].connectionHolders.length-1
                                      // if(res.WaterConnection[0].connectionHolders.length>2)
                                      // {
                                      //   index = 1
                                      // }
                                      if (connectionHolders && connectionHolders[0]) {
                                        applicantName = connectionHolders[0].proposedName;
                                      }
                                      // applicantName =get(res, `WaterConnection[0].connectionHolders[${index}].proposedName`, '')
                                    } else {
                                      applicantName = (0, _get2.default)(res, "WaterConnection[0].connectionHolders[" + index + "].proposedName", '');
                                    }
                                  }
                                  break;
                                case "WS_METER_UPDATE":
                                case "UPDATE_METER_INFO":
                                  activityType = 'Meter Update';
                                  break;
                                case "APPLY_FOR_METER_TESTING":
                                case "WS_METER_TESTING":
                                  activityType = 'Meter Testing';
                                  break;
                                case "WS_CONVERSION":
                                case "CONNECTION_CONVERSION":
                                  activityType = 'Tariff Change';
                                  break;
                                case "WS_REACTIVATE":
                                case "REACTIVATE_CONNECTION":
                                  activityType = 'Reactive Connection';
                                  break;
                                case "APPLY_FOR_TEMPORARY_TEMPORARY_CONNECTION":
                                  activityType = 'Temporary to Temporary Conversion';
                                  break;

                              }
                              var billGeneration_ = [{

                                div: div,
                                subDiv: subDiv,
                                applicationNumber: applicationNumber,
                                connectionNumber: connectionNumber,
                                receiptNumber: (0, _commons.getQueryArg)(window.location.href, "receiptNumber"),
                                activityType: activityType,
                                applicantName: applicantName,
                                applicantAddress: applicantAddress,
                                paymentReceiptDate: paymentReceiptDate,
                                dueAmount: dueAmount,
                                paidAmount: paidAmount,
                                status: 'Payment complete'
                              }];

                              (0, _api.httpRequest)("post", DOWNLOADRECEIPT.GET.URL, DOWNLOADRECEIPT.GET.ACTION, queryStr, { WSReceiptRequest: billGeneration_ }, { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                                res.filestoreIds[0];
                                if (res && res.filestoreIds && res.filestoreIds.length > 0) {
                                  res.filestoreIds.map(function (fileStoreId) {
                                    downloadReceiptFromFilestoreID(fileStoreId, "print", KeytenantId);
                                  });
                                } else {
                                  console.log("Error In Receipt Download");
                                }
                              });
                            });
                          } else {
                            console.log("Error In Receipt Download");
                          }
                        });
                        //
                      } catch (error) {
                        dispatch((0, _actions.toggleSnackbar)(true, { labelName: error.message, labelKey: error.message }, "error"));
                        console.log(error);
                      }
                    } else if (applicationNumber.includes("SW")) {

                      var wswc_search = {
                        GET: {
                          URL: "/sw-services/swc/_search",
                          ACTION: "_search"
                        }
                      };
                      (0, _api.httpRequest)("post", wswc_search.GET.URL, wswc_search.GET.ACTION, queryObject, [], { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                        res.SewerageConnections[0];
                        if (res && res.SewerageConnections && res.SewerageConnections.length > 0) {
                          var queryObjectP = [{ key: "tenantId", value: (0, _commons.getQueryArg)(window.location.href, "tenantId") }, { key: "uuids", value: res.SewerageConnections[0].propertyId }];
                          var wc_searchPropety = {
                            GET: {
                              URL: "/property-services/property/_search",
                              ACTION: "_search"
                            }
                          };
                          (0, _api.httpRequest)("post", wc_searchPropety.GET.URL, wc_searchPropety.GET.ACTION, queryObjectP, [], { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (resp) {
                            div = (0, _get2.default)(res, "SewerageConnections[0].div", '');
                            subDiv = (0, _get2.default)(res, "SewerageConnections[0].subdiv", '');
                            activityType = (0, _get2.default)(res, "SewerageConnections[0].activityType", '');
                            applicantName = (0, _get2.default)(res, "SewerageConnections[0].connectionHolders[0].name", '');
                            applicantAddress = (0, _get2.default)(res, "SewerageConnections[0].connectionHolders[0].correspondenceAddress", '');

                            connectionNumber = (0, _get2.default)(res, "SewerageConnections[0].connectionNo", '');

                            if (resp && resp.Properties && resp.Properties.length > 0) {
                              plotnumber = (0, _get2.default)(resp.Properties[0], "address.doorNo", '');
                              houseNo = (0, _get2.default)(resp.Properties[0], "address.plotNo", '');
                              if (houseNo === null || houseNo === undefined) {
                                houseNo = "NA";
                              }
                              sector = (0, _get2.default)(resp.Properties[0], "address.locality.name", '');
                              if (sector === undefined || sector === null) {
                                sector = (0, _get2.default)(resp.Properties[0], "address.locality.code", '');
                                sector = GetMdmsNameBycode(state, dispatch, "searchPreviewScreenMdmsData.ws-services-masters.swSectorList", sector);
                              }
                              applicantAddress = plotnumber + "," + houseNo + "," + sector;
                              //applicantAddress = `Plot number-${plotnumber},House number-${houseNo},Locality-${sector}`
                              applicantAddress = "Plot No/House No-" + plotnumber + ",Locality-" + sector;
                            }
                            if (activityType === null) {
                              activityType = "Sewarage Connection";
                            }
                            var billGeneration_ = [{

                              div: div,
                              subDiv: subDiv,
                              applicationNumber: applicationNumber,
                              connectionNumber: connectionNumber,
                              receiptNumber: (0, _commons.getQueryArg)(window.location.href, "receiptNumber"),
                              activityType: activityType,
                              applicantName: applicantName,
                              applicantAddress: applicantAddress,
                              paymentReceiptDate: paymentReceiptDate,
                              dueAmount: dueAmount,
                              paidAmount: paidAmount,
                              status: 'Payment complete'
                            }];
                            (0, _api.httpRequest)("post", DOWNLOADRECEIPT.GET.URL, DOWNLOADRECEIPT.GET.ACTION, queryStr, { WSReceiptRequest: billGeneration_ }, { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                              res.filestoreIds[0];
                              if (res && res.filestoreIds && res.filestoreIds.length > 0) {
                                res.filestoreIds.map(function (fileStoreId) {
                                  downloadReceiptFromFilestoreID(fileStoreId, "print", KeytenantId);
                                });
                              } else {
                                console.log("Error In Receipt Download");
                              }
                            });
                          });
                        } else {
                          console.log("Error In Receipt Download");
                        }
                      });
                    }
                  } else if (businessServiceInfo.code.includes('CTL')) {
                    var data = function data() {
                      var data1 = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "applicationDataForReceipt", {});
                      var data2 = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "receiptDataForReceipt", {});
                      var data3 = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "mdmsDataForReceipt", {});
                      var data4 = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "userDataForReceipt", {});
                      return (0, _extends3.default)({}, data1, data2, data3, data4);
                    };
                    var Licenses = state.screenConfiguration.preparedFinalObject.Licenses;
                    var Payments = payloadReceiptDetails.Payments;
                    var billAccountDetails = Payments[0].paymentDetails[0].bill.billDetails[0].billAccountDetails;

                    billAccountDetails = billAccountDetails.map(function (_ref13) {
                      var taxHeadCode = _ref13.taxHeadCode,
                          rest = (0, _objectWithoutProperties3.default)(_ref13, ["taxHeadCode"]);
                      return (0, _extends3.default)({}, rest, {
                        taxHeadCode: taxHeadCode.includes("_FEE") ? "TL_FEE" : taxHeadCode.includes("_PENALTY") ? "TL_TIME_PENALTY" : taxHeadCode.includes("_TAX") ? "TL_TAX" : taxHeadCode.includes("_ROUNDOFF") ? "TL_ROUNDOFF" : taxHeadCode.includes("REHRI_REGISTRATION_CHARGES") ? "TL_CHARGES" : taxHeadCode
                      });
                    });
                    Payments = [(0, _extends3.default)({}, Payments[0], { paymentDetails: [(0, _extends3.default)({}, Payments[0].paymentDetails[0], { bill: (0, _extends3.default)({}, Payments[0].paymentDetails[0].bill, { billDetails: [(0, _extends3.default)({}, Payments[0].paymentDetails[0].bill.billDetails[0], { billAccountDetails: billAccountDetails })] }) })] })];

                    var data1 = data();
                    var generateBy = JSON.parse((0, _localStorageUtils.getUserInfo)()).name;
                    (0, _api.httpRequest)("post", DOWNLOADRECEIPT.GET.URL, DOWNLOADRECEIPT.GET.ACTION, queryStr, { Payments: Payments, Licenses: Licenses, data1: data1, generateBy: generateBy }, { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                      res.filestoreIds[0];
                      if (res && res.filestoreIds && res.filestoreIds.length > 0) {
                        res.filestoreIds.map(function (fileStoreId) {
                          downloadReceiptFromFilestoreID(fileStoreId, "print", (0, _commons.getQueryArg)(window.location.href, "tenantId"));
                        });
                      } else {
                        console.log("Error In Receipt Download");
                      }
                    });
                  } else {
                    (0, _api.httpRequest)("post", DOWNLOADRECEIPT.GET.URL, DOWNLOADRECEIPT.GET.ACTION, queryStr, { Payments: payloadReceiptDetails.Payments }, { 'Accept': 'application/json' }, { responseType: 'arraybuffer' }).then(function (res) {
                      res.filestoreIds[0];
                      if (res && res.filestoreIds && res.filestoreIds.length > 0) {
                        res.filestoreIds.map(function (fileStoreId) {
                          downloadReceiptFromFilestoreID(fileStoreId, "print");
                        });
                      } else {
                        console.log("Error In Receipt Download");
                      }
                    });
                  }
                });
              } catch (error) {
                dispatch((0, _actions.toggleSnackbar)(true, { labelName: error.message, labelKey: error.message }, "error"));
                console.log(error);
              }
            } catch (exception) {
              alert('Some Error Occured while downloading Receipt!');
            }

          case 13:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, undefined);
  }));

  return function downloadprint(_x30, _x31) {
    return _ref12.apply(this, arguments);
  };
}();

exports.downloadprint = downloadprint;
var WNSConfigName = exports.WNSConfigName = function WNSConfigName() {
  return {
    ONE_TIME_FEE_WS: "PUBLIC_HEALTH_SERVICES_DIV2",
    ONE_TIME_FEE_SW: "PUBLIC_HEALTH_SERVICES_DIV4"

  };
};
var downloadBill = exports.downloadBill = function () {
  var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(consumerCode, tenantId) {
    var searchCriteria, FETCHBILL, DOWNLOADRECEIPT, billResponse, queryStr, pfResponse;
    return _regenerator2.default.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            searchCriteria = {
              consumerCode: consumerCode,
              tenantId: tenantId
            };
            FETCHBILL = {
              GET: {
                URL: "egov-searcher/bill-genie/billswithaddranduser/_get",
                ACTION: "_get"
              }
            };
            DOWNLOADRECEIPT = {
              GET: {
                URL: "/pdf-service/v1/_create",
                ACTION: "_get"
              }
            };
            _context12.next = 5;
            return (0, _api.httpRequest)("post", FETCHBILL.GET.URL, FETCHBILL.GET.ACTION, [], { searchCriteria: searchCriteria });

          case 5:
            billResponse = _context12.sent;
            queryStr = [{ key: "key", value: "consolidatedbill" }, { key: "tenantId", value: "ch" }];
            _context12.next = 9;
            return (0, _api.httpRequest)("post", DOWNLOADRECEIPT.GET.URL, DOWNLOADRECEIPT.GET.ACTION, queryStr, { Bill: billResponse.Bills }, { 'Accept': 'application/pdf' }, { responseType: 'arraybuffer' });

          case 9:
            pfResponse = _context12.sent;

            downloadReceiptFromFilestoreID(pfResponse.filestoreIds[0], 'download');

          case 11:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, undefined);
  }));

  return function downloadBill(_x33, _x34) {
    return _ref14.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ../lib/egov-common/ui-utils/commons.js
// module id = 1499
// module chunks = 895